import React from "react";
import Text from "components/Text";

const SectionHeader = ({ children, className = "" }) => {
  return (
    <Text
      color="#587E85"
      size="16px"
      weight="600"
      className={className}
    >
      {children}
    </Text>
  );
};

export default SectionHeader;

